import type { ReactNode } from 'react';

interface PreviewNoticeProps {
  children: ReactNode;
}

export default function PreviewNotice({ children }: PreviewNoticeProps) {
  return (
    <div role="note" className="flex items-start gap-3 rounded-lg border border-primary-200 bg-primary-50 px-4 py-3 text-[13px] leading-relaxed text-foreground-700">
      <span className="mt-0.5 flex h-4 w-4 shrink-0 items-center justify-center text-primary-600">
        <i className="ri-information-line" />
      </span>
      <div>{children}</div>
    </div>
  );
}